import { render, staticRenderFns } from "./ROATable.vue?vue&type=template&id=189f7d5f&scoped=true&"
import script from "./ROATable.vue?vue&type=script&lang=js&"
export * from "./ROATable.vue?vue&type=script&lang=js&"
import style0 from "./ROATable.vue?vue&type=style&index=0&id=189f7d5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f7d5f",
  null
  
)

export default component.exports